import axios from 'axios'
import { NOTIFICATION_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll() {




    return axios.get(NOTIFICATION_URL, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })


    // return axios.get(NOTIFICATION_URL, {
    //     headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    // })
}


// WEBPACK FOOTER //
// ./src/service/notification.js